import React, { useEffect, useState } from 'react'
import { getFileByFilename } from '../../../helpers/helper-file'
import { IData } from '../../../interfaces/table'

import { Container, Image as ImageElement } from './styles'

const Image = ({ value }: IData) => {
  const [url, setUrl] = useState('')

  useEffect(() => {
    function loadComponent() {
      setUrl(getFileByFilename(String(value)))
    }

    loadComponent()
  }, [value])

  return (
    <Container>
      <ImageElement src={url} />
    </Container>
  )
}

export default Image
